import { Injectable } from '@angular/core';
import { Http, Request, Response, ConnectionBackend, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { StorageService } from './storage.service';

/**
 *
 * Wraps the angular Http service to provide facilties for logging, expired auth detection, etc.
 *
 * @export
 * @class WrappedHttpService
 */
@Injectable()
export class WrappedHttpService {
  constructor(
    private http: Http,
    private storage: StorageService
  ) {
    console.debug('DEBUG >> http.service.ts:20: constructor()');
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:24: request()');
    console.debug('DEBUG >> http.service.ts:25: url: %s', url);
    console.debug('DEBUG >> http.service.ts:26: options: %O', options);

    let obs = this.http.request(url, options);

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:40: get()');
    console.debug('DEBUG >> http.service.ts:41: url: %s', url);
    console.debug('DEBUG >> http.service.ts:42: options: %O', options);

    let obs = this.http.get(url, options);
    console.log('http-wrapper: get');

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:57: post()');
    console.debug('DEBUG >> http.service.ts:58: url: %s', url);
    console.debug('DEBUG >> http.service.ts:59: body: %O', body);
    console.debug('DEBUG >> http.service.ts:60: options: %O', options);

    let obs = this.http.post(url, body, options);
    console.log('http-wrapper: post');

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:74: put()');
    console.debug('DEBUG >> http.service.ts:75: url: %s', url);
    console.debug('DEBUG >> http.service.ts:76: body: %O', body);
    console.debug('DEBUG >> http.service.ts:77: options: %O', options);

    let obs = this.http.put(url, body, options);

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:90: delete()');
    console.debug('DEBUG >> http.service.ts:91: url: %s', url);
    console.debug('DEBUG >> http.service.ts:92: options: %O', options);

    let obs = this.http.delete(url, options);

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:106: patch()');
    console.debug('DEBUG >> http.service.ts:107: url: %s', url);
    console.debug('DEBUG >> http.service.ts:108: body: %O', body);
    console.debug('DEBUG >> http.service.ts:109: options: %O', options);

    let obs = this.http.patch(url, body, options);

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:122: head()');
    console.debug('DEBUG >> http.service.ts:123: url: %s', url);
    console.debug('DEBUG >> http.service.ts:124: options: %O', options);

    let obs = this.http.head(url, options);

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  options(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug('DEBUG >> http.service.ts:138: options()');
    console.debug('DEBUG >> http.service.ts:139: url: %s', url);
    console.debug('DEBUG >> http.service.ts:140: options: %O', options);

    let obs = this.http.options(url, options);

    obs.subscribe(res => {
      let data = res.json();
      if (data.C4ErrorResponse) {
        this._handleError(data.C4ErrorResponse);
      }
    }, err => {
      this._handleError(err);
    });

    return obs;
  }

  private _handleError(err) {
    console.debug('DEBUG >> http.service.ts:154: _handleError()');
    console.debug('DEBUG >> http.service.ts:155: err: %O', err);

    if (!!err) {
      switch (err.code || err.status) {
        // client errors
        case 400: break;
        case 401: console.error('http: 401 Unauthorized'); break;
        case 402: break;
        case 403: break;
        case 404: break;
        case 405: break;
        // TODO: others?

        // server errors
        case 500: break;
        case 501: break;
        case 502: break;
        case 503: break;
        case 504: break;
        // TODO: others?

        default: console.error('http: unrecognized/unsupported HTTP status', err);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/http.service.ts